const popup = {
  state: {
    /* [푸시 알림 연계] 이벤트 이력/사전 예측 이벤트 이력 (공통) 팝업 */
    showCommonEventHistPopup: false,
    commonEventHistPopupParams: {},
    /* [푸시 알림 연계] 정기 점검 변경 이력 팝업 */
    showRegularCheckDetailInfoPopup: false,
    regularCheckDetailInfoPopupParams: {},
    /* [푸시 알림 연계] 작업 목록 팝업 */
    showWorkDetailPopup: false,
    workDetailPopupParams: {},
    /* [푸시 알림 연계] 작업 상세 팝업 */
    showWorkDetailsSlidingPopup: false,
    workDetailsSlidingPopupParams: {},
    /* [푸시 알림 연계] 이벤트 타임라인 팝업 */
    showEventTimelinePopup: false,
    eventTimelinePopupParams: {},
    /* 즐겨찾기 팝업 */
    showFavoritePopup: false,
    /* 사용자 정보 팝업 */
    showUserPopup: false,
    userPopupActiveTab: null,
    /* WatchAll Smart Search 팝업 */
    showSmartSearchPopup: false,
  },
  mutations: {
    setShowCommonEventHistPopup: (state, visible) => {
      state.showCommonEventHistPopup = visible;
    },
    setCommonEventHistPopupParams: (state, params) => {
      state.commonEventHistPopupParams = params;
    },
    setShowRegularCheckDetailInfoPopup: (state, visible) => {
      state.showRegularCheckDetailInfoPopup = visible;
    },
    setRegularCheckDetailInfoPopupParams: (state, params) => {
      state.regularCheckDetailInfoPopupParams = params;
    },
    setShowWorkDetailPopup: (state, visible) => {
      state.showWorkDetailPopup = visible;
    },
    setWorkDetailPopupParams: (state, params) => {
      state.workDetailPopupParams = params;
    },
    setShowWorkDetailsSlidingPopup: (state, visible) => {
      state.showWorkDetailsSlidingPopup = visible;
    },
    setWorkDetailsSlidingPopupParams: (state, params) => {
      state.workDetailsSlidingPopupParams = params;
    },
    setShowEventTimelinePopup: (state, visible) => {
      state.showEventTimelinePopup = visible;
    },
    setEventTimelinePopupParams: (state, params) => {
      state.eventTimelinePopupParams = params;
    },
    setShowFavoritePopup: (state, params) => {
      state.showFavoritePopup = params;
    },
    setShowUserPopup: (state, params) => {
      state.showUserPopup = params;
    },
    setUserPopupActiveTab: (state, value) => {
      state.userPopupActiveTab = value;
    },
    setShowSmartSearchPopupp: (state, params) => {
      state.showSmartSearchPopup = params;
    },
  },
  actions: {
    /**
     * [프레임 > 이벤트 /사전 예측 이벤트 팝업] visible 관리
     * (이벤트, 사전 예측 이벤트 푸시알림 연계 기능)
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openCommonEventHistPopup({ commit }, params) {
      commit('setCommonEventHistPopupParams', params);
      commit('setShowCommonEventHistPopup', true);
    },
    closeCommonEventHistPopup({ commit }) {
      commit('setShowCommonEventHistPopup', false);
      commit('setCommonEventHistPopupParams', {});
    },
    /**
     * [프레임 > 정기 점검 항목 변경 이력 팝업] visible 관리
     * (정기 점검 항목 변경 푸시알림 연계 기능)
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openRegularCheckDetailInfoPopup({ commit }, params) {
      commit('setRegularCheckDetailInfoPopupParams', params);
      commit('setShowRegularCheckDetailInfoPopup', true);
    },
    closeRegularCheckDetailInfoPopup({ commit }) {
      commit('setShowRegularCheckDetailInfoPopup', false);
      commit('setRegularCheckDetailInfoPopupParams', {});
    },
    /**
    * [프레임 > 작업 목록 팝업] visible 관리
    * (24시간 이내 예정 작업 푸시알림 연계 기능)
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openWorkDetailPopup({ commit }, params) {
      commit('setWorkDetailPopupParams', params);
      commit('setShowWorkDetailPopup', true);
    },
    closeWorkDetailPopup({ commit }) {
      commit('setShowWorkDetailPopup', false);
      commit('setWorkDetailPopupParams', {});
    },
    /**
     * [프레임 > 작업 상세 팝업] visible 관리
     * (작업 변경 푸시알림 연계 기능)
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openWorkDetailsSlidingPopup({ commit }, params) {
      commit('setWorkDetailsSlidingPopupParams', params);
      commit('setShowWorkDetailsSlidingPopup', true);
    },
    closeWorkDetailsSlidingPopup({ commit }) {
      commit('setShowWorkDetailsSlidingPopup', false);
      commit('setWorkDetailsSlidingPopupParams', {});
    },
    /**
     * [프레임 > 작업 상세 팝업] 작업 수정 버튼 click 감지
     * 작업 관리의 작업 설정 팝업을 open하기 위해 updateFlag 제어
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    updateWorkDetail({ commit }, params) {
      params.updateFlag = true;
      commit('setWorkDetailsSlidingPopupParams', params);
    },
    /**
    * [프레임 > 이벤트 타임라인 팝업] visible 관리
    * (구성 정보 변경 푸시알림 연계 기능)
     * @author jeee12
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openEventTimelinePopup({ commit }, params) {
      commit('setEventTimelinePopupParams', params);
      commit('setShowEventTimelinePopup', true);
    },
    closeEventTimelinePopup({ commit }) {
      commit('setShowEventTimelinePopup', false);
      commit('setEventTimelinePopupParams', {});
    },
    /**
    * 즐겨찾기 팝업을 연다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openFavoritePopup({ commit }) {
      commit('setShowFavoritePopup', true);
    },
    /**
     * 즐겨찾기 팝업을 닫는다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @return {[type]}        [description]
     */
    closeFavoritePopup({ commit }) {
      commit('setShowFavoritePopup', false);
    },
    /**
    * 사용자 정보 팝업을 연다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openUserPopup({ commit }, activeTab) {
      commit('setShowUserPopup', true);
      commit('setUserPopupActiveTab', activeTab);
    },
    /**
     * 사용자 정보 팝업을 닫는다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @return {[type]}        [description]
     */
    closeUserPopup({ commit }) {
      commit('setShowUserPopup', false);
      commit('setUserPopupActiveTab', null);
    },
    /**
    * Smart Search 팝업을 연다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    openSmartSearchPopup({ commit }) {
      commit('setShowSmartSearchPopupp', true);
    },
    /**
     * 사용자 정보 팝업을 닫는다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @return {[type]}        [description]
     */
    closeSmartSearchPopup({ commit }) {
      commit('setShowSmartSearchPopupp', false);
    },
  },
};

export default popup;



// WEBPACK FOOTER //
// ./src/store/modules/popup.js